<form [formGroup]="personForm" class="mt-6">
  <div class="row mt-6">
    <div class="col-md-8 offset-md-2">
      <div class="mb-2 mt-3">
        <h4 class="title"><i class="fas fa-user"></i> {{title | translate}}</h4>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <h5>{{ "TITLE.PASSWORD-UPDATE" | translate }}</h5>
          <div
            [innerHTML]="'MESSAGE.YOU-MUST-ENTER-PASSWORD-THAT-CONTAINS-UPPERCASE-LOWER-NUMBERS-AND-AT-LEST-ONE-SPECIAL-CHARACTER' | translate : { minLengthPassword : minLengthPassword, maxLengthPassword: maxLengthPassword}"></div>
        </div>
        <div class="col-md-6">
          <div class="form-row">
            <div class="form-group col">
              <label for="oldPasswordInput">{{ "LABEL.CURRENT-PASSWORD" | translate }}</label>
              <div class="input-group">
                <input [type]="viewActualPassword ? 'text' : 'password'"
                       class="form-control"
                       id="oldPasswordInput"
                       placeholder="{{ 'MESSAGE.ENTER-CURRENT-PASSWORD' | translate }}"
                       formControlName="oldPassword"
                       [(ngModel)]="person.oldPassword">
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa {{viewActualPassword?'fa-eye':'fa-eye-slash'}}"
                       (click)="toggleFieldTextType(OLD_PASSWORD)"></i>
                  </span>
                </div>
              </div>
              <div>
                <small *ngIf="isInvalidControl('oldPassword')"
                       class="text-danger">
                  {{getErrorMessageBy('oldPassword') | translate}}
                </small>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <label for="newPasswordInput">{{ "LABEL.PASSWORD" | translate }}</label>
              <div class="input-group">
                <input [type]="viewNewPassword ? 'text' : 'password'"
                       class="form-control"
                       id="newPasswordInput"
                       placeholder="{{ 'MESSAGE.ENTER-NEW-PASSWORD' | translate }}"
                       formControlName="newPassword"
                       [(ngModel)]="person.password"
                       [class.is-invalid]="isInvalidControl('newPassword')"
                       (keyup)="validatePassword()"
                       [attr.disabled]="disablePassword ? '' : null">
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa {{viewNewPassword?'fa-eye':'fa-eye-slash'}}"
                       (click)="toggleFieldTextType(NEW_PASSWORD)"></i>
                  </span>
                </div>
              </div>
              <label *ngIf="isSecurityHigh">{{"LABEL.SECURITY-LEVEL" | translate}}:
                <b class="text-primary">{{"LABEL.HIGH" | translate}}</b></label>
              <label *ngIf="isSecurityMedium">{{"LABEL.SECURITY-LEVEL" | translate}}:
                <b class="text-success">{{"LABEL.MEDIUM" | translate}}</b></label>
              <label *ngIf="isSecurityLow">{{"LABEL.SECURITY-LEVEL" | translate}}:
                <b class="text-secondary">{{"LABEL.LOW" | translate}}</b></label>
              <ul class="mt-2">
                <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                    *ngIf="isSecurityHigh">
                  <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.MINIMUM-LENGTH-12" | translate}}
                </li>
                <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                    *ngIf="isSecurityMedium">
                  <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.MINIMUM-LENGTH-8" | translate}}
                </li>
                <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                    *ngIf="isSecurityLow">
                  <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.MINIMUM-LENGTH-6" | translate}}
                </li>
                <li class="{{passwordControls?.hasUpperCase ? 'text-success':'text-danger'}}"
                    *ngIf="!isSecurityLow">
                  <i class="{{passwordControls?.hasUpperCase ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.CONTAINS-CAPITAL-LETTER" | translate}}
                </li>
                <li class="{{passwordControls?.hasLowerCase ? 'text-success':'text-danger'}}"
                    *ngIf="!isSecurityLow">
                  <i class="{{passwordControls?.hasLowerCase ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.CONTAINS-LOWERCASE-LETTER" | translate}}
                </li>
                <li class="{{passwordControls?.hasNumber ? 'text-success':'text-danger'}}"
                    *ngIf="!isSecurityLow">
                  <i class="{{passwordControls?.hasNumber ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.CONTAINS-A-NUMBER" | translate}}
                </li>
                <li class="{{passwordControls?.hasSpecialChar ? 'text-success':'text-danger'}}"
                    *ngIf="!isSecurityLow && !isSecurityMedium">
                  <i class="{{passwordControls?.hasSpecialChar ? 'fas fa-check': 'fas fa-times'}}"></i>
                  {{"MESSAGE.CONTAINS-SPECIAL-CHARACTER" | translate}}
                </li>
              </ul>
              <small
                *ngIf="personForm.get('newPassword').errors?.passwordComplexity && personForm.get('newPassword').touched"
                class="text-danger">
                {{"MESSAGE.PASSWORD-REQUIRED-MUST-MEET-REQUIREMENTS" | translate}}
                <span
                  *ngIf="!passwordControls?.hasNoSpaces">{{"MESSAGE.PASSWORD-DOES-NOT-CONTAIN-SPACE" | translate}}</span>
              </small>
              <div>
                <small *ngIf="isInvalidControl('newPassword')"
                       class="text-danger">
                  {{getErrorMessageBy('newPassword') | translate}}
                </small>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <label for="repeatNewPasswordInput">{{ "LABEL.REPEAT-PASSWORD" | translate }}</label>
              <div class="input-group">
                <input [type]="viewNewPasswordRepeated ? 'text' : 'password'"
                       class="form-control"
                       id="repeatNewPasswordInput"
                       placeholder="{{ 'MESSAGE.RE-ENTER-NEW-PASSWORD' | translate }}"
                       formControlName="repeatNewPassword"
                       [(ngModel)]="person.repeatNewPassword"
                       [class.is-invalid]="isInvalidControl('repeatNewPassword')"
                       (keyup)="validatePassword()"
                       [attr.disabled]="disablePassword ? '' : null">
                <div class="input-group-append">
                  <span class="input-group-text" id="repeatNewPassword">
                    <i class="fa {{viewNewPasswordRepeated?'fa-eye':'fa-eye-slash'}}"
                       (click)="toggleFieldTextType(NEW_REPEAT_PASSWORD)"></i>
                  </span>
                </div>
              </div>
              <div>
                <small *ngIf="isInvalidControl('repeatNewPassword')"
                       class="text-danger">
                  {{getErrorMessageBy('repeatNewPassword') | translate}}
                </small>
                <small
                  *ngIf="!isInvalidControl('newPassword') && !isInvalidControl('repeatNewPassword') && !areSamePasswords"
                  class="text-danger">
                  {{ "MESSAGE.PASSWORDS-DO-NO-MATCH" | translate }}
                </small>
              </div>
            </div>
          </div>
          <div class="form-row" style="float: right">
            <div class="form-group col custom-align-center">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox"
                       class="custom-control-input"
                       id="disablePasswordCheckbox"
                       [checked]="!disablePassword"
                       (click)="disablePasswordControls($event)">
                <label class="custom-control-label"
                       for="disablePasswordCheckbox">{{ "BUTTON.ENABLED" | translate }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <h5>{{ "TITLE.MAIL-UPDATE" | translate }}</h5>
        </div>
        <div class="col-md-6">
          <div class="form-row">
            <div class="form-group col">
              <label for="emailInput">{{ "LABEL.EMAIL-ADDRESS" | translate }}</label>
              <input type="text" class="form-control"
                     id="emailInput"
                     placeholder="{{ 'MESSAGE.ENTER-EMAIL-ADDRESS' | translate }}"
                     [(ngModel)]="person.email"
                     formControlName="email">
              <small *ngIf="isInvalidControl('email')"
                     class="text-danger">
                {{getErrorMessageBy('email') | translate}}
              </small>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <h5>{{ "TITLE.OTHER-DATA" | translate }}</h5>
        </div>
        <div class="col-md-6">
          <div class="form-row">
            <div class="form-group col">
              <label for="cellphoneInput">{{ "LABEL.CELL-PHONE-NUMBER" | translate }}</label>
              <input type="text" class="form-control"
                     id="cellphoneInput"
                     placeholder="{{ 'MESSAGE.ENTER-CELL-PHONE-NUMBER' | translate }}"
                     [(ngModel)]="person.cellphone"
                     formControlName="cellphone">
              <small *ngIf="isInvalidControl('cellphone')"
                     class="text-danger">
                {{getErrorMessageBy('cellphone') | translate}}
              </small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col">
              <label>{{ "LABEL.RUBRIC" | translate }}</label>
              <div class="custom-file content-file">
                <input type="file"
                       [disabled]="false"
                       class="custom-file-input"
                       accept="image/jpeg, image/png"
                       alife-file-to-base64
                       id="customRubricFile"
                       (change)="readSelectedRubric($event)"
                       (onFileChanged)="changeStatus2($event)">
                <div class="custom-file-label">
                  <label for="customRubricFile">
                    {{personForm.get('rubricFilename2Show').value ? personForm.get('rubricFilename2Show').value : 'MESSAGE.SELECT' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row text-right">
            <img [src]="defaultRubricSrc" #rubricPic style="{{styleDimensionsRubric}}" alt="Rubric">
          </div>
        </div>
      </div>
      <div class="row mb-3" [hidden]="!REQUIRED_CAPTCHA">
        <div class="col-md-6">
          <h5>{{ "TITLE.VERIFICATION" | translate }}</h5>
        </div>
        <div class="col-md-6">
          <div style="transform:scale(1.15);transform-origin:0;">
            <re-captcha formControlName="recaptchaReactive"></re-captcha>
          </div>
          <small *ngIf="isInvalidControl('recaptchaReactive')"
                 class="text-danger">
            {{ "MESSAGE.SUCCESSFUL-COMPLETION-OF-THE CAPTCHA-IS-REQUIRED" | translate }}
          </small>
        </div>
      </div>
      <div class="col-md-3 offset-md-9 mt-2">
        <div class="row">
          <div class="col-md-6 btn-save">
            <button type="button" class="btn btn-success w-100"
                    (click)="save()">
              <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}</button>
          </div>
          <div class="col-md-6 btn-cancel">
            <button type="button" class="btn btn-outline-danger w-100"
                    (click)="cancel()">
              <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<app-loading *ngIf="loading"></app-loading>
